import api from "./index";

// Property ID review queue (data team + super admins). Backend:
// property_management/views/property_id_review_views.py
const BASE = "property-management/property-id-review";

// { status, store, reason, search, page, page_size }
export const getPropertyIdReviews = (params = {}) => api.get(`${BASE}/`, { params });

export const getPropertyIdReview = (id) => api.get(`${BASE}/${id}/`);

export const getPropertyIdReviewMetrics = (params = {}) => api.get(`${BASE}/metrics/`, { params });

// Properties a reviewer can pick: an address or a Property ID.
export const searchPropertyIdCandidates = (q) => api.get(`${BASE}/search/`, { params: { q } });

// { decision: confirm | choose | separate_unit | no_match | resolved, property_id?, unit?, note? }
export const decidePropertyIdReview = (id, data) => api.post(`${BASE}/${id}/decide/`, data);

export const undoPropertyIdReview = (id) => api.post(`${BASE}/${id}/undo/`);
